import React from "react";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { useSessao } from "../../redux/sessao/sessaoHooks";
import { ModalCfgApp } from "../../components/modais/ModalCfgApp";
import { useSnack } from "../../redux/snack/snackHooks";
import Loader from "../../components/Generics/Loader";
import ModalGeneric from "../../components/Generics/ModalGeneric";
import { useCfgGeral } from "../../redux/cfgGeral/cfgGeralHooks";
import Copyright from "../../components/layout/Copyrigth";
import GridCenter from "../../components/Generics/GridCenter";
import ModalRecuperarSenha from "../../components/modais/ModalRecuperarSenha";
import LogoTripLog from "../../assets/Logo_vermelho.png";

const LoginPage: React.FC = () => {
  const mostrarSnack = useSnack();
  const [usuario, setUsuario] = useState("");
  const [senha, setSenha] = useState("");
  const [verSenha, setVerSenha] = useState(false);
  const [loading, setLoading] = useState(false);
  const [, login] = useSessao();
  const [openModalCfg, setOpenModalCfg] = useState(false);
  const [cfgGeral, setCfgGeral] = useCfgGeral();
  const [openModalRecuperarSenha, setOpenModalRecuperarSenha] = useState(false);

  const frases = [
    "⏳ Carregando...",
    "🔍 Verificando credenciais...",
    "🔌 Conectando ao servidor...",
    "🗄️ Acessando banco de dados...",
    "🔑 Autenticando usuário...",
    "🔄 Sincronizando informações...",
    "✅ Validando dados...",
    "⚙️ Preparando ambiente...",
    "🚀 Iniciando sessão...",
    "🛡️ Verificando permissões...",
  ];
  const [frase, setFrase] = useState(frases[0]);
  useEffect(() => {
    const intervalo = setInterval(() => {
      const novaFrase = frases[Math.floor(Math.random() * frases.length)];
      setFrase(novaFrase);
    }, 1000);
    return () => clearInterval(intervalo);
  }, []);
  const onLogin = async () => {
    try {
      setLoading(true);
      await login(usuario, senha);
      setLoading(false);
    } catch (err: any) {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      if (err.data === "Usuário inexistente ou senha inválida") {
        mostrarSnack("Usuário inexistente ou senha inválida", "error");
        return;
      }
      mostrarSnack(`${err}`, "error");
      console.log("Erro no login", err);
    }
  };
  useEffect(() => {
    const callback = (event: any) => {
      if (event.key === "*") {
        event.preventDefault();
        setOpenModalCfg(true);
      }
    };
    document.addEventListener("keydown", callback);
    return () => {
      document.removeEventListener("keydown", callback);
    };
  }, []);
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #0f1f2c, #1f3a52)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          padding: "40px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "30px" }}>
          <img src={LogoTripLog} width={200} height="auto" alt="Logo TripLog" />
        </div>

        <TextField
          fullWidth
          label="Código de acesso"
          value={cfgGeral.tenantCode}
          onChange={(e) =>
            setCfgGeral({ ...cfgGeral, tenantCode: e.target.value })
          }
          onKeyPress={(e) => e.key === "Enter" && onLogin()}
          disabled={loading}
          style={{ marginBottom: "20px" }}
        />

        <TextField
          fullWidth
          label="Usuário"
          value={usuario}
          onChange={(e) => setUsuario(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && onLogin()}
          disabled={loading}
          style={{ marginBottom: "20px" }}
        />

        <TextField
          fullWidth
          label="Senha"
          value={senha}
          onChange={(e) => setSenha(e.target.value)}
          type={verSenha ? "text" : "password"}
          onKeyPress={(e) => e.key === "Enter" && onLogin()}
          disabled={loading}
          style={{ marginBottom: "20px" }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setVerSenha(!verSenha)} edge="end">
                  {verSenha ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onLogin}
          disabled={loading}
          style={{
            height: "45px",
            borderRadius: "8px",
            fontWeight: "bold",
            marginBottom: "10px",
          }}
        >
          Entrar
        </Button>

        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <Typography
            variant="body2"
            style={{ cursor: "pointer", color: "#0f1f2c" }}
            onClick={() => setOpenModalRecuperarSenha(true)}
          >
            Esqueceu a senha?{" "}
            <span style={{ textDecoration: "underline" }}>Recupere aqui</span>
          </Typography>
        </div>
      </div>

      {/* Footer */}
      <div
        style={{
          position: "absolute",
          bottom: "10px",
          textAlign: "center",
          width: "100%",
          color: "white",
        }}
      >
        <Copyright textColor="white" />
      </div>

      {/* Modais */}
      {openModalRecuperarSenha && (
        <ModalRecuperarSenha
          open={openModalRecuperarSenha}
          onClose={() => setOpenModalRecuperarSenha(false)}
          usuario={usuario}
          codigoAcesso={cfgGeral.tenantCode}
          setUsuario={setUsuario}
          setCodigoAcesso={(codigoAcesso: string) => {
            setCfgGeral({ ...cfgGeral, tenantCode: codigoAcesso });
          }}
        />
      )}

      {openModalCfg && (
        <ModalCfgApp
          open={openModalCfg}
          onClose={() => setOpenModalCfg(false)}
        />
      )}

      {loading && (
        <ModalGeneric
          open={loading}
          hideCloseBootom
          style={{ background: "transparent", border: "none" }}
          onClose={() => {}}
        >
          <GridCenter>
            <Grid item xs={12} style={{ color: "white" }}>
              <h2>{frase}</h2>
            </Grid>
            <Grid item xs={12} style={{ textAlign: "center", display: "flex" }}>
              <Loader color="white" />
            </Grid>
          </GridCenter>
        </ModalGeneric>
      )}
    </div>
  );
};
export default LoginPage;
